import { appLocalStorage } from '@/app/shared/commonURLs';

//let ScreeningUrl = appLocalStorage.ScreeningUrl;
let MedicalHistoryUrl = appLocalStorage.MedicalHistoryUrl;
//let ScreeningODataUrl = appLocalStorage.ScreeningODataUrl;
//let PatientProblemUrl = appLocalStorage.PatientProblemURL;
//let ProductManagementODataUrl = appLocalStorage.ProductManagementODataUrl;
//let ProductManagementUrl = appLocalStorage.ProductManagementUrl;
//let allergyURl = appLocalStorage.AllergyServiceUrl;

export class uRls {
    constructor() {
        debugger
        this.MedicalHistoryServicesList = URls();
    }
}

const MedicalHistoryModuleURL = new uRls();

export { MedicalHistoryModuleURL };


function URls() {
    var services = {};

    services["GetPatientMedicalHistorySummary"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'MedicalHistory/GetPatientMedicalHistorySummary?',
    }
    services["GetObsGynInitData"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'ObsGynMedicalHistory/GetObsGynInitData?',
    } 
    services["GetMedicationInitData"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'MedicalHistory/GetMedicationInitData?',
    } 
    services["GetFamilyHistoryInitData"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'MedicalHistory/GetFamilyHistoryInitData?',
    }
    services["SetPatientMedicalHistory"] = {
        Method: 'Post',
        URL: MedicalHistoryUrl + 'MedicalHistory/SetPatientMedicalHistory',
    }
    

    services["GetPatientSocialHistoryData"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'SocialMedicalHistory/GetPatientSocialHistoryData?',
    }

    services["GetPatientSurgicalHistory"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'SurgicalMedicalHistory/GetPatientSurgicalHistory?',
    }
    return services
}